module.exports = __webpack_public_path__ + "img/messages-empty.9e7a1cf.png";